import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing token
    const token = localStorage.getItem("customer_token");
    const savedCustomer = localStorage.getItem("customer_data");
    
    if (token && savedCustomer) {
      setCustomer(JSON.parse(savedCustomer));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/customer/login`, { email, password });
    const { access_token, customer: customerData } = response.data;
    
    localStorage.setItem("customer_token", access_token);
    localStorage.setItem("customer_data", JSON.stringify(customerData));
    setCustomer(customerData);
    
    return customerData;
  };

  const register = async (name, email, password, phone) => {
    const response = await axios.post(`${API}/customer/register`, { 
      name, 
      email, 
      password,
      phone: phone || null
    });
    const { access_token, customer: customerData } = response.data;
    
    localStorage.setItem("customer_token", access_token);
    localStorage.setItem("customer_data", JSON.stringify(customerData));
    setCustomer(customerData);
    
    return customerData;
  };

  const logout = () => {
    localStorage.removeItem("customer_token");
    localStorage.removeItem("customer_data");
    setCustomer(null);
  };

  const saveProduct = async (productId) => {
    const token = localStorage.getItem("customer_token");
    if (!token) throw new Error("Not logged in");
    
    await axios.post(`${API}/customer/save/${productId}`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    // Update local state
    const updatedCustomer = {
      ...customer,
      saved_products: [...(customer.saved_products || []), productId]
    };
    setCustomer(updatedCustomer);
    localStorage.setItem("customer_data", JSON.stringify(updatedCustomer));
  };

  const unsaveProduct = async (productId) => {
    const token = localStorage.getItem("customer_token");
    if (!token) throw new Error("Not logged in");
    
    await axios.delete(`${API}/customer/save/${productId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    // Update local state
    const updatedCustomer = {
      ...customer,
      saved_products: (customer.saved_products || []).filter(id => id !== productId)
    };
    setCustomer(updatedCustomer);
    localStorage.setItem("customer_data", JSON.stringify(updatedCustomer));
  };

  const isProductSaved = (productId) => {
    return customer?.saved_products?.includes(productId) || false;
  };

  const getToken = () => localStorage.getItem("customer_token");

  return (
    <AuthContext.Provider value={{
      customer,
      loading,
      login,
      register,
      logout,
      saveProduct,
      unsaveProduct,
      isProductSaved,
      getToken,
      isLoggedIn: !!customer
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
